import { createExpandedSections } from "@shared/components/menus/expanded-sections"

// Beside UnitMenu rather than in it: a module exporting a component may export nothing else, or
// Vite's Fast Refresh gives up on the whole file (enforced by react-refresh/only-export-components).

/** Which sections start expanded. Union of the editable + readonly options. */
export const expandedSections = createExpandedSections([
  "copy-paste",
  "print-share",
  "copy-readonly",
  "print-readonly",
])
